import constants from '../constants';
import type { AppThunkVoid } from '../types';

export const setAppValues = (data): AppThunkVoid => {
  return (dispatch) =>
    dispatch({
      type: constants.SET_APP_VALUES,
      payload: data,
    });
};
